/*
 * @Author: 🐝
 * @Date: 2023-09-11 14:49:14
 * @LastEditors: Ant🐜
 * @LastEditTime: 2025-11-05 16:57:39
 * @Description: 描述一下
 */
import axios from '../utils/axios'

// 获取奖金列表
export function getBonusList(params) {
  return axios.post('/user/apiUserAh5Service/getBonusList', params)
}
// 获取我的奖金汇总
export function getBonusSummary(params) {
  return axios.post('/user/apiUserAh5Service/getBonusSummary', params)
}
// 获取我的奖金汇总统计数据
export function getBonusStatistics(params) {
  return axios.post('/user/apiUserAh5Service/GetPersonalBonusStatistics', params)
}

//获取奖金类型options
export function searchFundsType(params = {}) {
  return axios.post('/funds/apiFundsMwService/searchFundsType', params)
}

//获取联赛类型options
export function getLeagueJtTypesApi(params) {
  return axios.post('/league/apiLeagueService/getLeagueJtTypes', params)
}
//获取联赛类型列表
export function getLeagueJtListApi(params) {
  return axios.post('/league/apiLeagueService/getLeagueJtList', params)
}
//获取联赛类型统计数据
export function getLeagueJtStatisticsApi(params) {
  return axios.post('/league/apiLeagueService/getLeagueJtStatistics', params)
}
